import React, { useEffect } from 'react';
import { Avatar, Card, Col, Row, Typography } from 'antd';

interface IProps {
  job: any;
}

const TechnicianCard: React.FC<IProps> = ({ job }) => {
  const { Text } = Typography;
  useEffect(() => {}, []);
  return (
    <>
      <Card style={{ borderRadius: '5px' }}>
        <Row
          justify="start"
          gutter={[32, 48]}
          style={{ paddingTop: '5px' }}
        >
          <Col>
            <Avatar
              size={{
                xs: 64,
                sm: 64,
                md: 64,
                lg: 64,
                xl: 80,
                xxl: 100,
              }}
              src={job.idCard}
            />
          </Col>
          <Col flex={10}>
            <Text strong style={{ fontSize: '20px' }}>
              {job.technician?.name}
            </Text>
            <div>
              <Text style={{ color: '#727A86' }}>
                {job.technician?.phone}
              </Text>
            </div>
            <div>
              <Text style={{ color: '#727A86' }}>
                {job.description}
              </Text>
            </div>
          </Col>
        </Row>
      </Card>
    </>
  );
};

export default TechnicianCard;
